import { HTMLAttributes } from 'react';

export interface IFeedbackCapture extends HTMLAttributes<HTMLDivElement> {
  heading: string;
  optionLabels: Record<'yes' | 'no', string>;
  successMessage: string;
}

export enum FeedbackStep {
  INITIAL = 'initial',
  TEXT_INPUT = 'textInput',
  COMPLETE = 'complete'
}

export interface IFeedbackCaptureStep {
  testIdPrefix: string;
  next?: () => void;
}
